var map = {
	"./Pattern01.png": "ff89",
	"./Pattern02.png": "8a3a",
	"./Pattern03.png": "6300",
	"./Pattern04.png": "60b0",
	"./Pattern05.png": "d292",
	"./Pattern06.png": "c634"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a0bd";